module.exports = {
      id: "google-play-usage",
      viewBox: "0 0 180 53.33",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#google-play",
      toString: function () {
        return this.url;
      }
    }